import { Source } from "@lytra/frontend-common/__generated__/graphql";
import {
  AtSign,
  Bot,
  Database,
  MessageCircle,
  MessageCircleQuestion,
  PenLine,
  Plug,
  StickyNote,
} from "lucide-react";
import type { ReactNode } from "react";

export const CONVERSATION_PRIORITY_COLOR_MAP = {
  LOW: "bg-gray-500/50",
  MEDIUM: "bg-yellow-500/50",
  HIGH: "bg-red-500/50",
  URGENT: "bg-fuchsia-500/50",
};

// Solid variants — listed statically so Tailwind's JIT actually generates them.
// Stripping "/50" from the map above at runtime defeats Tailwind's static scan
// and yields no background (white-on-white badge).
export const CONVERSATION_PRIORITY_SOLID_COLOR_MAP = {
  LOW: "bg-gray-500",
  MEDIUM: "bg-yellow-500",
  HIGH: "bg-red-500",
  URGENT: "bg-fuchsia-500",
};

// P1 (Urgent) is the highest priority — matches the P1/P2/P3/P4 incident-ticket convention.
export const CONVERSATION_PRIORITY_NUMBER_MAP = {
  URGENT: 1,
  HIGH: 2,
  MEDIUM: 3,
  LOW: 4,
};

// Both maps are keyed on every Source plus the "unknown" fallback, and typed as total
// Records so a new Source in the schema fails the build here. ADVASCO and DATABASE were
// added to the enum without being added here, and because the maps are indexed by a
// `Source`, conversations from those two rendered with no icon and no source label.
type ConversationSourceKey = Source | "unknown";

export const CONVERSATION_SOURCE_TEXT_MAP: Record<
  ConversationSourceKey,
  string
> = {
  ["unknown"]: "Unbekannt",
  [Source.Ai]: "AI",
  [Source.Chat]: "Chat",
  [Source.Email]: "E-Mail",
  [Source.Advasco]: "Advasco",
  [Source.Database]: "Datenbank",
  [Source.Note]: "Notiz",
  [Source.Manual]: "Manuell",
};

export const CONVERSATION_SOURCE_ICON_MAP: Record<
  ConversationSourceKey,
  ReactNode
> = {
  ["unknown"]: <MessageCircleQuestion size={10} />,
  [Source.Ai]: <Bot size={10} />,
  [Source.Chat]: <MessageCircle size={10} />,
  [Source.Email]: <AtSign size={10} />,
  [Source.Advasco]: <Plug size={10} />,
  [Source.Database]: <Database size={10} />,
  [Source.Note]: <StickyNote size={10} />,
  [Source.Manual]: <PenLine size={10} />,
};
